import { AdminApiService } from "./../admin-api.service";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ViewContainerRef } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { universoService } from '../services/universos/universo.service';
@Component({
  selector: 'app-load-data',
  templateUrl: './load-data.component.html',
  styleUrls: ['./load-data.component.scss']
})
export class LoadDataComponent implements OnInit {
  public currentFile: any;
  public __sending: boolean;
  public List: any;
  public storeList: any;
  public _totalStores: number;
  public _itemsByPage: number;
  public _currentPage: number;
  public _totalPages: number;
  seleccion;
  seleccion1;
  constructor(
    public toastr: ToastrService,
    vcr: ViewContainerRef,
    private adminApi: AdminApiService,
    private universe: universoService
  ) { }


  async ngOnInit() {
    this.__sending = false;
    await this.loadBrands();
    // await this.loadStores();
  }
  uploadCSV(ev) {
    this.__sending = true;
    if (!ev || !ev.target || !ev.target.files[0]) {
      this.toastr.error("Debe seleccionar un fichero.");
      return;
    }

    console.log("Uploading CSV %c%s", "color: green", ev.target.files[0].name);

    // if (ev.target.files[0].type !== 'text/csv') {
    //   console.log(
    //     'Error uploading CSV, is not a CSV current file type: %c%s',
    //     'color: red',
    //     ev.target.files[0].type
    //   );
    //   this.toastr.error(
    //     'El fichero debe ser del tipo CSV, entre en Excel y exportelo en el formato correcto.'
    //   );
    //   return;
    // }

    let reader = new FileReader();
    let file = ev.target.files[0];
    console.log(file);
    reader.readAsDataURL(file);
    reader.onload = () => { 
      let tempFile = {
        filename: file.name,
        type: file.type,
        data: reader.result.split(",")[1]
      };

      let formData: FormData = new FormData();

      formData.append("csvfile", file, file.name);
      console.log(formData);
      this.adminApi.uploadDataCSV(formData , this.seleccion)
        .then(res => {
          this.toastr.success(
            "El fichero se ha subido correctamente, en cuanto haya sido procesado se mostrará en la pantalla de NPS."
          );
        })
        .catch(err => {
          this.toastr.error(err, "Ha habido un error al subir el archivo.");
        });
    };
  }
  async loadBrands() {
   await this.universe.getBrands().then(res =>{
      console.log(res);
      this.List = res;
    })
  }
  async loadStores() {
    console.log('search tiendas')
    await this.adminApi.listStores( this._currentPage, this._itemsByPage, {} ).then((res: any) => {
      console.log(res)
      this.storeList = res.items;
      this._totalStores = res.total;
      this._totalPages = Math.floor(res.total / this._itemsByPage) + 1;
    }); 
  }
}
